import { SQLiteDBConnection } from '@capacitor-community/sqlite'

export const dbStore: Record<string, SQLiteDBConnection | undefined> = {

}
